import {
    APP_SET_LEFT_DRAWER_OPEN,
    APP_SET_RIGHT_DRAWER_OPEN,
    APP_SET_ALERT,
    APP_SET_SETTINGS_CONTENT,
    APP_UPDATE_ROUTES,
    APP_ACTIVE_PAGE_TITLE,
    APP_ACTIVE_PAGE_ID,
    APP_SET_PREVIOUS_ROUTE,
    APP_SET_MODAL_CONTENT,
    APP_SET_TOOLTIP_CONTENT,
    APP_TOOLBAR_HEIGHT,
    APP_SET_GANTT_USER_SELECTIONS,
	APP_SET_UUID
} from "./appTypes";

export const initialState = {
    // Layout
    leftDrawerOpen: false,
    leftDrawerWidth: 240,
    rightDrawerOpen: false,
    rightDrawerWidth: 360,
    toolbarHeight: 0,
    // Notifications
    alert: {
        title: null,
        message: null,
        severity: null,
        timeout: null
    },
    // Routes
    routes: [],
    pageTitle: null,
    pageID: null,    // Current Page ID Name as defined in Config
    previousRoute: null,
    // Settings Panel
    settingsIcon: null,
    settingsLocation: null,
    settingsContent: null,
    // Modal
    modalContent: null,
    // Tooltip
    tooltipContent: null,
    // Gantt
    ganttUserSelections: [],
	// Global UUID
	uuid: null
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case APP_SET_LEFT_DRAWER_OPEN:
            return {
                ...state,
                leftDrawerOpen: action.payload
            };
        case APP_SET_RIGHT_DRAWER_OPEN:
            return {
                ...state,
                rightDrawerOpen: action.payload
            };
        case APP_TOOLBAR_HEIGHT:
            return {
                ...state,
                toolbarHeight: action.payload
            };
        case APP_SET_ALERT:
            return {
                ...state,
                alert: {
                    title: action.payload.title,
                    message: action.payload.message,
                    severity: action.payload.severity,
                    timeout: action.payload.timeout
                }
            };
        case APP_SET_SETTINGS_CONTENT: {
            return {
                ...state,
                settingsIcon: action.payload.icon,
                settingsLocation: action.payload.content.location,
                settingsContent: action.payload.content.content
            }
        }
        case APP_SET_MODAL_CONTENT: {
            return {
                ...state,
                modalContent: action.payload
            }
        }
        case APP_SET_TOOLTIP_CONTENT: {
            return {
                ...state,
                tooltipContent: action.payload
            }
        }
        case APP_UPDATE_ROUTES: {
            return {
                ...state,
                routes: action.payload
            }
        }
        case APP_SET_PREVIOUS_ROUTE: {
            return {
                ...state,
                previousRoute: action.payload
            }
        }
        case APP_ACTIVE_PAGE_TITLE: {
            return {
                ...state,
                pageTitle:  action.payload.pageTitle
            }
        }
        case APP_ACTIVE_PAGE_ID:
            return {
                ...state,
                pageID: action.payload
            };
        case APP_SET_GANTT_USER_SELECTIONS: {
            return {
                ...state,
                ganttUserSelections: action.payload
            }
        }
		case APP_SET_UUID: {
			return {
				...state,
				uuid: action.payload
			}
		}
        default:
            return state;
    }
};
